/**
 * Panel Tests API Endpoints
 * Nested under /instruments/{instrumentId}/panels/{panelId}/tests
 */
export const PANEL_TESTS_ENDPOINTS = {
  /**
   * Get all tests in a panel.
   * @method GET
   * @endpoint /instruments/{instrumentId}/panels/{panelId}/tests
   */
  PANEL_TESTS: (instrumentId: number, panelId: number) => `/instruments/${instrumentId}/panels/${panelId}/tests`,

  /**
   * Add a test to a panel.
   * @method POST
   * @endpoint /instruments/{instrumentId}/panels/{panelId}/tests
   */
  CREATE_PANEL_TEST: (instrumentId: number, panelId: number) => `/instruments/${instrumentId}/panels/${panelId}/tests`,

  /**
   * Update includeWhenFixed / includeWhenJoined flags for a panel-test.
   * @method PUT
   * @endpoint /instruments/{instrumentId}/panels/{panelId}/tests/{testId}
   */
  UPDATE_PANEL_TEST: (instrumentId: number, panelId: number, testId: number) =>
    `/instruments/${instrumentId}/panels/${panelId}/tests/${testId}`,

  /**
   * Remove a test from a panel.
   * @method DELETE
   * @endpoint /instruments/{instrumentId}/panels/{panelId}/tests/{testId}
   */
  DELETE_PANEL_TEST: (instrumentId: number, panelId: number, testId: number) =>
    `/instruments/${instrumentId}/panels/${panelId}/tests/${testId}`,
} as const;
